export const MAX_CART_NUM = 99;
export const MIN_CART_NUM = 0;

export const ECO_CART_STORAGE_KEY = 'ECO_CART_DATA';
export const ECO_CART_DEFAULT_SKU_TITLE = 'DEFAULT TITLE';
